import { ContextMenuVariant } from "@/components/ui/ContextMenu/types";
import { Action } from "@/components/ui/DropdownMenu/types";

export const convertActionsToContextMenuItems = <DataT>(
  actions: Action<DataT>[],
) => {
  const contextMenuItems = actions.map((action) => {
    if (action.id === "divider") {
      return {
        id: "divider",
        isDivider: true,
      };
    } else {
      return {
        id: action.label || "",
        label: action.label,
        onClick: action.onClick,
        variant:
          action.variant === "destructive"
            ? ContextMenuVariant.DESTRUCTIVE
            : ContextMenuVariant.PRIMARY,
        icon: action.icon,
      };
    }
  });

  return contextMenuItems;
};
